import '../styles/home.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowDown } from '@fortawesome/free-solid-svg-icons'
import { faGooglePlay } from '@fortawesome/free-brands-svg-icons'
import img1 from '../imgs/prank_img.png'
import img2 from '../imgs/finder_img.png'
import img3 from '../imgs/bruh_img.png'
import img4 from '../imgs/clipper_img.png'
import googlePlayLogo from '../imgs/google_paly_logo.png'
import Fade from 'react-reveal/Fade'
import Flip from 'react-reveal/Flip'
import popper from "../imgs/popper_logo.png"
import screen1 from "../imgs/screen1.png"
import screen2 from "../imgs/screen2.png"
import screen3 from "../imgs/screen3.png"
import screen4 from "../imgs/screen4.png"





export default function Home() {
    return (
        <div className="home">
            <Fade top>
                <h1>Latest Apps</h1>

                <div className='appsCard'>
                    <div className="gallery">
                        <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.bianca.apps.hairclippersimulatorprankjoke">
                            <img src={img1} alt="Cinque Terre" width="600" height="400" />
                        </a>
                        <div className="desc">Prank your friends and simulate the sound and sensation of a real hair clipper.</div>
                    </div>
                    <div className="gallery">
                        <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.bianca.apps.handclapfindmyphone">
                            <img src={img2} alt="Cinque Terre" width="600" height="400" />
                        </a>
                        <div className="desc">Never lose your device again! The app locates it when you simply clap your hands.</div>
                    </div>

                    <div className="gallery">
                        <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.bianca.apps.flashlight.call.notification.alert">
                            <img src={img3} alt="Cinque Terre" width="600" height="400" />
                        </a>
                        <div className="desc">Phone flashes on calls, messages and notifications & flash visual effects tools.</div>
                    </div>

                    <div className="gallery">
                        <a target="_blank" rel="noopener" href="https://play.google.com/store/apps/details?id=com.bianca.apps.counter.pushups.workout">
                            <img src={img4} alt="Cinque Terre" width="600" height="400" />
                        </a>
                        <div className="desc">Track Push ups effortlessly with our app. Stay organized, boost productivity!</div>
                    </div>
                </div>


                <button className="button"><a className="buttonClass" href='https://play.google.com/store/apps/dev?id=6256207236238699098' rel="noopener noreferrer"><span>View all on Google <FontAwesomeIcon icon={faGooglePlay} /></span></a> </button>


                <div className='scroll' >
                    <h2>See Our  Latest Creation</h2>
                    <p>Scroll down</p>
                    <FontAwesomeIcon icon={faArrowDown} />
                    <div className='line' />
                </div>
            </Fade>




            <div className='screenOne'>


                <div className='box1'>
                    <Fade left>
                        <img src={popper} alt="logo" width="100" height="100" />
                        <Flip flip>
                            <h2>Flash Alerts - Call & Message</h2>
                        </Flip>
                    </Fade>
                </div>

                <Fade right>
                    <img src={screen1} alt="screen" width={270} height={560}/>
                </Fade>

            </div>
            <div className='screenThree'>
                <Fade right>
                    <img src={screen4} alt="logo" width={270} height={560} />
                </Fade>
                <div className='box3'>
                    <h4><span role='img'>📖</span> How is working?</h4>
                    <p className='textbox3'>
                    Choose your preferred settings for calls and messages. 
                    Customize flash patterns, duration, and intensity. 
                    Activate 'Do Not Disturb' mode when serenity calls. Elevate your experience with the added tools: Screen Light Mode, Text Light Message, and Strobe Light Screen! 
                    </p>
                </div>


            </div>

            <div className='screenTwo' >


                <div className='box2'>
                    <p className='textbox2'><span role="img">📋</span>Extra Tools
                        <ul>
                            <li>📺 Screen Light Mode: Transform your entire screen into a vibrant light show! </li>
                            <li>💬 Text Light Message: Craft LED text that dances across your phone screen, adding a personal touch to your notifications.</li>
                            <li>🌠 Strobe Light: Elevate your party or music festival experience with captivating strobe light effects. </li>
                          


                        </ul>

                    </p>
                </div>
                <Fade right>
                    <img src={screen3} alt="logo" width={270} height={560}  />
                </Fade>

            </div>

            <div className='screenThree'>
                <Fade right>
                    <img src={screen2} alt="logo" width={270} height={560}  />
                </Fade>
                <div className='box3'>
                    <h4>🆙 Key Features</h4>
                    <p className='textbox3'>

                    <ul>
                        <li>📴 Mode Customization </li>
                        <li>⏸️ Active Screen Detection </li>
                        <li>🔋 Battery Saver </li>
                        <li>🔒 Smart Activation </li>
                    </ul>
                 
                    </p>
                </div>


            </div>

            <div className='screenFour'>


                <div className='box4'>
                    <h2>Get it from</h2>

                    <div className='googlelogo'>
                        <a href='https://play.google.com/store/apps/details?id=com.bianca.apps.flashlight.call.notification.alert' target="_blank" rel="noopener noreferrer"><img src={googlePlayLogo} alt="google" width="120" height="35" /></a>
                    </div>



                </div>



            </div>








        </div>

    );
}